module.exports = __webpack_public_path__ + "img/addon-custom_avatar.eb9ef546.png";